<template>
  <div class="activities">

    <span>Write a new comment:</span>
    <div style="display: flex">
      <el-input
        v-model="text"
        @keydown.native.enter="onClickAddComment"
        class="p-0 mr-2"
        ref="chat_input"></el-input>
      <el-button @click="onClickAddComment" class="px-3">
        <font-awesome-icon :icon="['far', 'comment']" />
      </el-button>
    </div>

    <!-- TODO component -->
    <!-- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -->

    <div
      v-for="activity in activity_list_show"
      :key="activity.$key"
      :class="[activity.activityType, 'list-item']">

      <template v-if="activity.activityType === 'USER_COMMENT'">
        <div>

          <p>{{activity.text}}</p>

          <span style="font-size: 8pt; color: gray">
            {{activity.createdAt|fromNow}} by
            <user-mini-avatar :user-id="activity.userId" size="small" />
          </span>

          <font-awesome-icon
            v-if="activity.userId === currentUserId"
            icon="trash"
            class="inline-icon"
            style="float: right"
            @click="onDeleteComment(activity.$id)" />

        </div>
      </template>

      <!-- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -->

      <template v-if="activity.activityType === 'LOGGED'">
        <div style="display: flex">
          <div class="activity-icon">
          </div>
          <div>
            <user-mini-avatar :user-id="activity.userId" :show-name="true" size="small" />

            finished

            <!-- TODO: activity.userId stimmt nur manchmal !!! ... id sollte aber da sein -->
            <router-link :to="'/goal/' + goalId + '/member/' + activity.userId + '/task/' + activity.taskId">
              <strong>{{task_name(activity.taskId)}}</strong>
            </router-link>

            {{activity.createdAt|fromNow}}
          </div>
        </div>
      </template>

      <!-- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -->

      <div class="mt-1">
        <el-popover
          trigger="hover"
          content="No likes yet. Be the first to give a like.">
          <div v-if="activity.$state.likesBy && Object.keys(activity.$state.likesBy).length > 0">
            <strong>Liked by:</strong>
            <div
              v-for="(_, user) in activity.likesBy"
              :key="user">
              <user-mini-avatar :user-id="user" :show-name="true" size="small" />
            </div>
          </div>

          <a slot="reference" @click.prevent="onClickLike(activity)" href="">
            <i class="fe fe-thumbs-up mr-1"></i>
            <strong>{{activity.numOfLikes}}</strong>
          </a>
        </el-popover>

        <a href="#" @click.prevent="onShowHideReplies( activity.$id )" class="ml-2">
          <font-awesome-icon :icon="['far', 'comment']" />
          {{activity_replies(activity.$id).length}} comments
        </a>
      </div>

      <template v-if="show_reply_enable_map[ activity.$id ]">
        <div
          v-for="reply in activity_replies(activity.$id)"
          :key="reply.$key"
          class="comment-reply-item">

          <p>&#8220;{{reply.text}}&#8221;</p>

          <span style="font-size: 9pt;">
            {{reply.createdAt|fromNow}} by
            <user-mini-avatar :user-id="reply.userId" :show-name="false" class="ml-1" size="small" />
          </span>

          <font-awesome-icon
            v-if="reply.userId === currentUserId"
            icon="trash"
            class="inline-icon"
            style="float: right"
            @click="onRemoveReply( reply.$id )" />
        </div>

        <div v-if="activity_replies(activity.$id).length > 0 && false /*!show_reply_enable_input_map[ activity.$id ] */" class="m-1 pl-3">
          <a href="#" @click.prevent="onShowHideReplies( activity.$id )">
            <font-awesome-icon :icon="['far', 'comment']" />
            reply
          </a>
        </div>

        <div v-if="true /* show_reply_enable_input_map[ activity.$id ] */" style="display: flex" class="mt-1">
          <el-input
            @keydown.native.enter="onClickAddReply(activity.$id)"
            v-model="reply_text_map[activity.$id]"
            size="mini"
            class="p-0 mr-1"></el-input>
          <el-button @click="onClickAddReply(activity.$id)" size="mini" class="px-2">
            <font-awesome-icon :icon="['far', 'comment']" />
          </el-button>
        </div>
      </template>
    </div>

    <el-button @click="onShowMore" size="mini" type="secondary" class="btn-block my-2">show more</el-button>

    <!-- <pre style="font-size:8pt">{{activity_list}}</pre> -->
    <!-- <pre class="mini-pre">{{all_tasks}}</pre> -->
  </div>
</template>

<script>
import Vue from 'vue'
import util from '@/util'

// TODO: Think of smoething better then "likes"
// TODO: Also use likes list for news / gif popups
// TODO: Deal with deleted tasks
// TODO: Reply auch für normale comments

export default {
  name: "Activities",
  props: {
    goalId: {
      Type: String,
      Default: ""
    },
  },
  data: () => ({
    text: '',
    reply_text_map: {},
    show_reply_enable_map: {},
    show_reply_enable_input_map: {},
    query_limit: 50,
  }),
  mounted() {
    // this.activity_listen( this.goalId );

    /* This willo automatically update the relative time every minute */
    this.updateTimer = setInterval(() => {
      this.$forceUpdate();
    }, 1000 * 60 )

    /* Workaournd since el-input does not support @keyup.enter */
    /*
    let chatInputElement = this.$refs.chat_input.$el;
    chatInputElement = chatInputElement.getElementsByTagName('input')[0];
    this.chatInputEventListener = chatInputElement.addEventListener('keypress', (e) => {
      if (!e) e = window.event;
      let keyCode = e.keyCode || e.which;
      if ( keyCode === 13 ) {
        this.onClickAddComment();
        return false;
      }
    })
    */
  },
  beforeDestroy() {
    clearInterval( this.updateTimer );
    // if ( this.chatInputEventListener ) {
    //   window.removeEventListener('resize', this.chatInputEventListener)
    // }
  },
  computed: {
    activity_list() {
      // TODO: Testen ob das funktioniert - werden hier alte subscriptions gelöscht??
      // TODO: !!! Query bezieht sich auch auf Replies !!!

      let activities = this.$models.activity
        .with({ goalId: this.goalId })
        .subscribeQuery({ key: 'createdAt', limit: -this.query_limit })
        .itemsAsArray()

      return activities
    },

    activity_list_show() {
      return this.activity_list
        .filter( activity => activity.activityType !== 'USER_REPLY' )
        .sort(util.sorter.by_createdAt)
        .reverse()
        // .slice(0, this.query_limit) // QUERY
    },

    all_tasks() {
      // TODO: Just write cached name to activity
      let all_tasklists = this.$models.task
        .with({ goalId: this.goalId })
        .getters
        .lane_task_list_all_users

      let tasklist = {};
      for ( let commitmentId in all_tasklists ) {
        all_tasklists[ commitmentId ].forEach(task => {
          tasklist[ task.$id ] = task;
        })
      }
      return tasklist
    },

    currentUserId() {
      return this.$models.user.defaultUserId;
    }
  },
  methods: {
    activity_replies( activity_id ) {
      // TODO move to compnentn and use getter !
      return this
        .activity_list
        .filter( activity => {
          return activity.activityType === 'USER_REPLY'
              && activity.originalActivityId === activity_id
        });
    },

    task_name(task_id) {
      let task = this.all_tasks[ task_id ]
      return task && task.name ? task.name : 'N/A'
    },

    onShowHideReplies( activity_id ) {
      if ( activity_id in this.show_reply_enable_map ) {
        Vue.delete( this.show_reply_enable_map, activity_id )
      } else {
        Vue.set( this.show_reply_enable_map, activity_id, true)
        Vue.set( this.reply_text_map, activity_id, '' )
      }
    },

    onDeleteComment(activity_id) {
      this.$api.activity_delete({
        activity_id: activity_id,
        goal_id:     this.goalId
      })
    },

    onRemoveReply(activity_id) {
      this.onDeleteComment(activity_id);
    },

    onClickAddComment() {
      this.$api.activity_create_comment({
        goal_id: this.goalId,
        text:    this.text,
      });
      this.text = '';
      setTimeout(() => { this.$forceUpdate(); }, 1500);
    },

    onClickAddReply( activity_id ) {
      this.$api.activity_create_reply({
        goal_id:     this.goalId,
        activity_id: activity_id,
        text:        this.reply_text_map[ activity_id ],
      }).then(() => {
        this.reply_text_map[ activity_id ] = ''
      })
    },

    onClickLike(activity) {
      if ( activity.$state.likesBy
        && activity.$state.likesBy[ this.$models.user.defaultUserId ] ) {
        // TODO: Also implement security rule
        return false;
      }
      this.$api.activity_like({
        activity_id: activity.$id,
        goal_id:     this.goalId
      });
    },

    onShowMore() {
      // console.log("onShowMore todo")
      this.query_limit += 50;
    }
  }
}
</script>

<style>
.activities .list-item {
  border-bottom: 1px solid #e0e0e0;
  padding: 0.5rem 0;
  margin-top: 0.25rem;
  font-size: 11pt;
}
.activities .comment-reply-item {
  /*
  border: 1px solid #e0e0e0;
  border-radius: 3px;
  background: white;
  padding: 0.5rem;
  margin-top: 0.25rem;
  */
  /*
  border-bottom: 1px solid #e0e0e0;
  padding: 0.3rem;
  */
  padding: 0 0.3rem;
  border-left: 2px solid #c0c4cc;
  margin-top: 6px;
  margin-left: 1rem;
}
.activities .comment-reply-item p {
  margin-bottom: 0.25em;
  font-size: 11pt;
}
/* stylelint-disable-next-line */
.activities .USER_COMMENT {
  /* background: #f8f8f8; */
}
/* stylelint-disable-next-line */
.activities .LOGGED {
  /* background: #f5ffec; */
  margin-bottom: 0.25em;
}
.activities .el-input input {
  padding: 0 3px;
}
/* .activities img.user-mini-image {
  margin-top: -1px;
  margin-left: 0px;
  border-radius: 3px;
  margin-right: 1px;
} */
.activities .activity-icon {
  background: #5eba00;
  flex: 0 0 5px;
  margin-right: 4px;
  border-radius: 2px;
}
</style>
